import styled from 'styled-components';

import { Icon } from '@/ui/Icon';

type LiveEventHighlightsInformerBannerProps = {
  children: React.ReactNode;
};

const RootStyled = styled.div`
  ${({ theme }) => theme.typography.body3};
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  background-color: #fff8f3;
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.warning.onContainer};

  svg {
    width: 16px;
    height: 16px;
    padding-top: 2px;
  }
`;

export const LiveEventHighlightsInformerBanner = ({ children }: LiveEventHighlightsInformerBannerProps): JSX.Element => {
  return (
    <RootStyled>
      <Icon icon={['far', 'circle-info']} />
      {children}
    </RootStyled>
  );
};
